module.exports = __webpack_public_path__ + "static/img/ikonaGaleria-OFF.5aebb814.png";